/**
 * ResponseRoboCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ResponseRobo} from '@/model/resource/ResponseRobo'

/* TODO: review generated class */
@HttpExclude()
export class ResponseRoboCollection extends PageCollection<ResponseRobo> {
  constructor() {
    super(ResponseRobo)
  }

  queryAsPage() {
    return this.listResponseRobo()
  }

  async listResponseRobo() {
    return await Request.get(`/admin/response-robo`, {params: this.params})
      .name('listResponseRobo')
      .as(this)
      .getResponse()
  }

  async listCsvResponseRobo() {
    return await Request.get(`/admin/response-robo/csv`, {params: this.params})
      .name('listCsvResponseRobo')
      .as(this)
      .getResponse()
  }
}
